import * as R from 'ramda'
import { FlatPatientNote } from '@/store/modules/patient-note/getters'
import { FlatPatientWithEvents } from '@/store/modules/patient-with-events/getters'
import { getUserName } from '@/utils/patients'
import { USER_TIME_ZONE } from '@/utils/time'
import { getFriendlyEventName } from '@/view-model/patient-event-constants/MemberPatientEvents'
import { URGENT_EVENT_SEVERITY } from '@/utils/constants'
import { getNoteId } from '@/utils/notes'
import { PatientWithEventsEvent } from '@/jsonapi/PatientWithEvents'

export type MixedEvent = {
  id: string | null
  timestamp: number
  timezone: string | null
  content: string
  color: string
  reportedBy: string
  isEditable: boolean
}

export function createMixedEvents(options: {
  patientNotes: FlatPatientNote[]
  patientWithEvents: FlatPatientWithEvents
  colors: any // vuetify color object (this.$vuetify.theme.themes.light)
  userId: string
}): MixedEvent[] {
  const convertedPatientNotes = options.patientNotes.map(note => ({
    id: getNoteId(note),
    timestamp: note.createdTimestamp,
    timezone: null,
    content: note.content,
    color: options.colors.primary,
    reportedBy: getUserName(note),
    isEditable: note.userId === options.userId,
  }))

  const convertedEvents = R.pathOr([], ['events'], options.patientWithEvents).map((event: PatientWithEventsEvent) => ({
    id: null,
    timestamp: event.eventTimestamp,
    timezone: options.patientWithEvents.timezone || USER_TIME_ZONE,
    content: getFriendlyEventName(event.eventName),
    color: event.eventSeverity < URGENT_EVENT_SEVERITY ? options.colors.orange : options.colors.red,
    reportedBy: '',
    isEditable: false,
  }))

  const mergedContents = [...convertedPatientNotes, ...convertedEvents]
  return mergedContents.sort((a, b) => b.timestamp - a.timestamp)
}
